import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'slider-item',
  template: `
      <ng-content></ng-content>
  `,
  styleUrls: ['./slider-item.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SliderItemComponent {
}
